module.exports = __webpack_public_path__ + "img/logo-company-9.6cc9dc7a.png";